const _ = {
  YELLOW_1: "#FFF1CC",
  YELLOW_2: "#FFDB80",
  YELLOW_3: "#FFCC4D",
  YELLOW_4: "#FFB700",
  YELLOW_5: "#E58600",
  YELLOW_6: "#B25900",
  ORANGE_1: "#FFDDCC",
  ORANGE_2: "#FFC2A3",
  ORANGE_3: "#FFAA80",
  ORANGE_4: "#FF884D",
  ORANGE_5: "#EC5B13",
  ORANGE_6: "#B23C00",
  PURPLE_1: "#FFE0FD",
  PURPLE_2: "#FFC2FA",
  PURPLE_3: "#FFA3F7",
  PURPLE_4: "#FF80F4",
  PURPLE_5: "#D926CA",
  PURPLE_6: "#AA099C",
  GREEN_1: "#D0FBE5",
  GREEN_2: "#89F5BF",
  GREEN_3: "#40F098",
  GREEN_4: "#00E573",
  GREEN_5: "#00B259",
  GREEN_6: "#007038",
  BLUE_1: "#D6F5FF",
  BLUE_2: "#99E5FF",
  BLUE_3: "#66D9FF",
  BLUE_4: "#33CCFF",
  BLUE_5: "#0086E5",
  BLUE_6: "#0055CC",
  BLACK_1: "#0D0D0D",
  BLACK_2: "#141414",
  BLACK_3: "#191919",
  BLACK_4: "#252525",
  BLACK_5: "#313131",
  WHITE_1: "#FFFFFF",
  WHITE_2: "#FAFAFA",
  WHITE_3: "#F5F5F5",
  WHITE_4: "#EBEBEB",
  WHITE_5: "#DADADA",
  BLACK_T_02: "rgba(0, 0, 0, 0.02)",
  BLACK_T_04: "rgba(0, 0, 0, 0.04)",
  BLACK_T_08: "rgba(0, 0, 0, 0.08)",
  BLACK_T_15: "rgba(0, 0, 0, 0.15)",
  BLACK_T_20: "rgba(0, 0, 0, 0.20)",
  BLACK_T_38: "rgba(0, 0, 0, 0.38)",
  BLACK_T_60: "rgba(0, 0, 0, 0.6)",
  BLACK_T_87: "rgba(0, 0, 0, 0.87)",
  WHITE_T_03: "rgba(255, 255, 255, 0.03)",
  WHITE_T_05: "rgba(255, 255, 255, 0.05)",
  WHITE_T_10: "rgba(255, 255, 255, 0.1)",
  WHITE_T_15: "rgba(255, 255, 255, 0.15)",
  WHITE_T_38: "rgba(255, 255, 255, 0.38)",
  WHITE_T_60: "rgba(255, 255, 255, 0.6)",
  WHITE_T_87: "rgba(255, 255, 255, 0.87)",
  GREY_1: "#F6F6F6",
  GREY_2: "#E0E0E0",
  GREY_3: "#B3B3B3",
  GREY_4: "#808080",
  REAL_BLACK: "#000000",
  REAL_BLACK_60: "rgba(0, 0, 0, 0.6)",
  REAL_BLACK_50: "rgba(0, 0, 0, 0.5)",
  REAL_BLACK_30: "rgba(0, 0, 0, 0.3)",
  REAL_BLACK_15: "rgba(0, 0, 0, 0.15)",
  REAL_BLACK_10: "rgba(0, 0, 0, 0.1)",
  BLACK: "#2B2B2B",
  BLACK_65: "rgba(43, 43, 43, 0.65)",
  BLACK_75: "rgba(43, 43, 43, 0.75)",
  BLACK_50: "rgba(43, 43, 43, 0.5)",
  BLACK_10: "rgba(43, 43, 43, 0.1)",
  WHITE: "#FFFFFF",
  WHITE_10: "#D9D9D9",
  WHITE_20: "#E6E6E6",
  WHITE_30: "#F2F2F2",
  WHITE_70: "rgba(255, 255, 255, 0.7)",
  RED: "#C22300",
  FLOWER: "#DE5EE0",
  TRANSPARENT: "transparent"
};
function E() {
  return _;
}
const F = ["YELLOW", "ORANGE", "PURPLE", "GREEN", "BLUE"];
export {
  E as default,
  F as hues
};
//# sourceMappingURL=clrs.js.map
